import React, { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import environment from '@/environment';
import {
  Core,
  ConstructionCard,
  FieldGroup,
  FloatingLabelFormField,
  Form,
  FormSection,
  useContainerProps,
  Page,
  SelectAsyncControl,
} from '@everfi/reactifi';
import { useTranslation } from 'react-i18next';

export interface TeacherGradesAndTopicsData {
  grades_ages: number[];
  first_grade_age_selected_id: number;
  topics: number[];
  first_topic_selected_id: number;
}

export interface TeacherSetupProps {
  jwt: string;
  submitGradesAndTopics?: (jwt: string, data: TeacherGradesAndTopicsData) => {};
}

const TeacherSetup: FC<TeacherSetupProps> = props => {
  props = useContainerProps(props);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { jwt, submitGradesAndTopics } = props;

  const handleTeacherSetup = async (data: TeacherGradesAndTopicsData) => {
    if (submitGradesAndTopics) {
      const response = await submitGradesAndTopics(jwt, data);
      if (response) {
        navigate('/teacher_registration/setup');
      }
    }
  };

  return (
    <Page pageType="parent" contentType="cards" title={''} backButton={false} usePageWrapper={true}>
      <ConstructionCard
        title={t('Tell us more about you!')}
        alwaysExpanded={true}
        data-object-id="sso-teacher-setup-card"
      >
        <Core.Typography variant="p">
          {t('Customize your EVERFI experience by selecting the grade(s) and topic(s) you teach.')}
        </Core.Typography>
        <Form
          buttonGroupClass="modal-footer"
          data={{}}
          saveButtonText={t('Link Account')}
          addAction={handleTeacherSetup}
        >
          <FormSection>
            <FieldGroup>
              <FloatingLabelFormField name="grades_ages" caption={t('Grade or Age Group')}>
                <SelectAsyncControl
                  authToken={jwt}
                  dataUrl={`${environment.apiBasePath.HOMEROOM}/label_entries/grades_ages`}
                  displayProperty="name"
                  isClearable={false}
                  isMulti={true}
                  placeholder=""
                />
              </FloatingLabelFormField>
            </FieldGroup>
            <FieldGroup>
              <FloatingLabelFormField name="topics" caption={t('Topics')}>
                <SelectAsyncControl
                  authToken={jwt}
                  dataUrl={`${environment.apiBasePath.HOMEROOM}/label_entries/topics`}
                  displayProperty="name"
                  isClearable={false}
                  isMulti={true}
                  placeholder=""
                />
              </FloatingLabelFormField>
            </FieldGroup>
          </FormSection>
        </Form>
      </ConstructionCard>
    </Page>
  );
};

export default TeacherSetup;
